import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

export const FORWARD_FILLING_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.FORWARD_FILLING_OVERBOOKS]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Overbooks',
  },
  [CompanyFactKey.FORWARD_FILLING_UNAPPROVED]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Unapproved',
  },
  [CompanyFactKey.FORWARD_FILLING_NOTES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Notes',
    conflictStrategy: ConflictStrategy.APPEND,
  },
}

export const BACKFILLING_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.BACKFILLING_BACKFILLABLE]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Backfillable',
  },
  [CompanyFactKey.BACKFILLING_TIME_LIMIT]: {
    schemaVersion: CompanyFactSchemaVersion.NUMBER_WITH_NOTES_V1,
    displayName: 'Time Limit',
  },
  [CompanyFactKey.BACKFILLING_PREFERENCES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Preferences',
  },
  [CompanyFactKey.BACKFILLING_TIER_REQUIREMENT]: {
    schemaVersion: CompanyFactSchemaVersion.TIER_REQUIREMENT_V1,
    displayName: 'Tier Requirement',
  },
  [CompanyFactKey.BACKFILLING_NOTES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Notes',
    conflictStrategy: ConflictStrategy.APPEND,
  },
}
